import React from 'react';
import { Typography } from 'antd';
import { CountChatSessionResultDto } from 'types';

interface DashboardChatStatsProps {
    getChatSessionDetails?: CountChatSessionResultDto;
}

const DashboardChatStats: React.FC<DashboardChatStatsProps> = ({
    getChatSessionDetails
}) => {
    return (
        <div className="grid grid-cols-3 gap-4 mt-4">
            <div className="bg-white w-[192px] h-[90px] shadow rounded-lg flex flex-col justify-center pl-4">
                <Typography.Text className="text-sm text-left text-[#868D97]">Đang chờ</Typography.Text>
                <Typography.Text className="text-2xl font-bold text-gray-900 text-left">
                    {getChatSessionDetails?.totalChatSessionWaiting || 0}
                </Typography.Text>
            </div>
            <div className="bg-white w-[192px] h-[90px] shadow rounded-lg flex flex-col justify-center pl-4">
                <Typography.Text className="text-sm text-left text-[#868D97]">Đang xử lý</Typography.Text>
                <Typography.Text className="text-2xl font-bold text-gray-900 text-left">
                    {getChatSessionDetails?.totalChatSessionProcessing || 0}
                </Typography.Text>
            </div>
            <div className="bg-white w-[192px] h-[90px] shadow rounded-lg flex flex-col justify-center pl-4">
                <Typography.Text className="text-sm text-left text-[#868D97]">Đã xử lý</Typography.Text>
                <Typography.Text className="text-2xl font-bold text-gray-900 text-left">
                    {getChatSessionDetails?.totalChatSessionCompleted || 0}
                </Typography.Text>
            </div>
        </div>
    );
};

export default React.memo(DashboardChatStats);
